export const SET_POSTS: string = 'SET_POSTS';
export const SET_POSTS_ERROR: string = 'SET_POSTS_ERROR';
export const RESET_POSTS: string = 'RESET_POSTS';
